const styles = ({ COLORS, BREAKPOINTS }) => ({
  container: {
    maxWidth: '1280px',
    margin: '0 auto 70px'
  },
  island: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '16px',
    flexShrink: '0',
    marginRight: '30px',
    marginBottom: '10px'
  },
  img: {
    width: '60px',
    borderRadius: '100%',
    display: 'block',
    marginRight: '20px'
  },
  icon: {
    backgroundColor: COLORS.BLUE.NORMAL,
    borderRadius: '100%',
    width: '80px',
    height: '80px',
    marginRight: '20px',
    display: 'flex',
    alignItems: 'center',
    flexShrink: '0',
    justifyContent: 'center',
    '& svg': {
      fontSize: '40px',
      color: '#fff'
    }
  },
  content: {
    '& strong': {
      display: 'block'
    },
    '& a': {
      fontWeight: 'bold',
      color: COLORS.BLUE.NORMAL,
      textDecoration: 'none'
    }
  },
  ctas: {
    justifyContent: 'center'
  },
  cta: {
    color: '#fff !important',
    display: 'block',
    textAlign: 'center',
    marginBottom: '18px'
  },
  desc: {
    justifyContent: 'center',
    [`@media (max-width: ${BREAKPOINTS.SM})`]: {
      display: 'none'
    }
  },
  copy: {
    height: '100%'
  },
  first: {
    marginBottom: 0,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'start',
    [`@media (max-width: 1160px)`]: {
      flexDirection: 'column',
      alignItems: 'start'
    }
  },
  last: {
    border: 'none'
  },
  documents: {
    '& > li': {
      fontSize: '16px',
      fontWeight: 'bold',
      marginBottom: '10px'
    },
    '& a': {
      color: COLORS.BLUE.NORMAL,
      textDecoration: 'none'
    }
  }
})

export default styles
